/**
 * Pays d'une adresse de client (constat API3-06, décision 9 du 19/10/2026) : code ISO 3166-1
 * alpha-2, la France par défaut. Le Factur-X l'exige pour l'acheteur (BR-11) ; le PDF imprime
 * le nom d'un pays étranger. Les noms viennent d'`Intl.DisplayNames` en français, sans liste
 * de libellés à tenir à jour.
 */

/** Codes officiellement attribués par l'ISO 3166-1 (249). */
export const COUNTRY_CODES = (
  'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ '
  + 'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR '
  + 'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP '
  + 'KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT '
  + 'MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW '
  + 'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG '
  + 'UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'
).split(' ');

export const DEFAULT_COUNTRY = 'FR';

const KNOWN = new Set(COUNTRY_CODES);

export function isCountryCode(value: unknown): value is string {
  return typeof value === 'string' && KNOWN.has(value);
}

let names: Intl.DisplayNames | undefined;

/** Nom français d'un pays (« Allemagne ») ; le code lui-même s'il est inconnu. */
export function countryName(code: string): string {
  names ??= new Intl.DisplayNames(['fr'], { type: 'region' });
  return (isCountryCode(code) && names.of(code)) || code;
}

/** Choix d'un pays : la France d'abord, puis les autres dans l'ordre alphabétique français. */
export function countryChoices(): { value: string; label: string }[] {
  const others = COUNTRY_CODES.filter((code) => code !== DEFAULT_COUNTRY)
    .map((code) => ({ value: code, label: countryName(code) }))
    .sort((a, b) => a.label.localeCompare(b.label, 'fr'));
  return [{ value: DEFAULT_COUNTRY, label: countryName(DEFAULT_COUNTRY) }, ...others];
}
